import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, RegexValidator, TextField } from '../../Components/Form';
import { useAccount } from '../../Data/Voip';

const CustomSMSName = () => {
    const {account, updateCustomSMSName} = useAccount();
    
    return <>
        <TopBar left="BackBtn" title="Custom SMS Name" />

        <Page>

            <div className="prose pb-3">
                <p>
                    Having a custom SMS name allows your business to be easily recognized by your customers.<br />
                    Instead of receiving messages from an unknown number, your customers will see your business name.
                </p>
            </div>

            <Form data={account} waitForData onSubmit={(d) => updateCustomSMSName(d.customSMSName)} afterSubmit={() => window.history.back()}>
                <TextField
                    name="customSMSName"
                    label="Custom SMS Name"
                    validators={[
                        RegexValidator(
                            '^[a-zA-Z][a-zA-Z0-9 ]{1,9}[a-zA-Z]$',
                            'Please check your custom SMS name meets the requirements below.'
                        )
                    ]}
                />
                
                <Actions submit={{label: 'Save'}} />
            </Form>

            <div className="prose pt-3">
                <p>
                    To reliably deliver your message to all networks the name must follow these rules:
                </p>

                <ul>
                    <li>Must be between 3 and 11 characters</li>
                    <li>Must only contain letters and numbers (but cannot start or end with a number)</li>
                    <li>Must not contain spaces or special characters</li>
                </ul>
            </div>

        </Page>
    </>
}

export default CustomSMSName;